export const GET_SYS_INFO_REQUEST = 'GET_SYS_INFO_REQUEST'
export const GET_SYS_INFO_SUCCESS = 'GET_SYS_INFO_SUCCESS'
export const GET_SYS_INFO_FAILED = 'GET_SYS_INFO_FAILED'
